module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Light.381d8503.woff2";